export const ROLE_LABELS = {
  patron: "Patron",
  koordinator: "Koordinatör",
  mudur: "Şube Müdürü",
  personel: "Personel",
};

export const roleLabel = (u) => u?.role_name || ROLE_LABELS[u?.role] || u?.role;

export const SCOPE_LABELS = { all: "Tüm şubeler", branch: "Kendi şubesi", self: "Sadece kendi satışları" };
export const SCOPE_BASE = { all: "patron", branch: "mudur", self: "personel" };

export const MONTH_NAMES = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
];

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });
  } catch { return iso; }
}

export function groupByBasket(list) {
  const groups = [];
  const idx = {};
  for (const s of list) {
    const k = s.basket_id || s.id;
    if (idx[k] === undefined) { idx[k] = groups.length; groups.push({ key: k, code: s.basket_code, items: [] }); }
    groups[idx[k]].items.push(s);
  }
  return groups.map((g) => ({
    ...g,
    items: [...g.items].sort((a, b) => (a.created_at < b.created_at ? -1 : 1)),
    first: g.items[0],
    qty: g.items.reduce((a, x) => a + (x.quantity || 0), 0),
    points: g.items.reduce((a, x) => a + (x.points || 0), 0),
  }));
}

export function fmtNum(n) {
  if (n == null) return "0";
  return Number(n).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
}

export function roleBadgeClass(role) {
  const map = {
    patron: "bg-amber-500/20 text-amber-300 border-amber-500/40",
    koordinator: "bg-blue-500/20 text-blue-300 border-blue-500/40",
    mudur: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
    personel: "bg-slate-500/20 text-slate-300 border-slate-500/40",
    custom: "bg-fuchsia-500/15 text-fuchsia-200 border-fuchsia-500/40",
  };
  return map[role] || map.personel;
}
